import { render, staticRenderFns } from "./bgs-page.vue?vue&type=template&id=8667c6d6"
import script from "./bgs-page.vue?vue&type=script&lang=js"
export * from "./bgs-page.vue?vue&type=script&lang=js"
import style0 from "./bgs-page.vue?vue&type=style&index=0&id=8667c6d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports